import { createContext, useContext } from "react";

export const FieldStackContext = createContext(false);

export const useFieldStackSpacing = () => useContext(FieldStackContext);
